import {
    ApiHandler,
    createHandlerChainRunner,
    HasOnSuccess,
    HasOnError,
} from "@insite/client-framework/HandlerCreator";
import { searchSME, SMESearchResultModel } from "@tCentro/Services/CENSMESearchService";

export interface SMESearchParameter extends HasOnSuccess<SMESearchResultModel>, HasOnError<string> {
    query?: string;
    id?: string;
    entity?: string;
}

type HandlerType = ApiHandler<SMESearchParameter, { apiResult: SMESearchResultModel }>;

export const SearchSME: HandlerType = async props => {
    try {
        const result = await searchSME({
            query: props.parameter.query,
            id: props.parameter.id,
            entity: props.parameter.entity,
        });
        if (props.parameter.onSuccess) {
            props.parameter.onSuccess(result);
        }
    } catch (error: any) {
        if (props.parameter.onError) {
            props.parameter.onError(error?.message ?? "Search failed");
        }
    }
};

export const chain = [SearchSME];
const getSMESearchData = createHandlerChainRunner(chain, "getSMESearchData");
export default getSMESearchData;
